export default class MaterialColorsController {
  constructor(ProductsDataProvider, ProductPartsDataProvider, $stateParams) {
    "ngInject";
    this.ProductsDataProvider = ProductsDataProvider;
    this.ProductPartsDataProvider = ProductPartsDataProvider;

    let
      product = ProductsDataProvider.products.findOne({slug: $stateParams.product}),
      materials = product.materials,
      material = materials
        .find((material) => material.slug == $stateParams.material),
      productColors = material
        .spec.colors,
      allColors = ProductPartsDataProvider
        .colors
        .find({})
        .map((color) => Object.assign({}, color));

    allColors.forEach((color) => {
      color.assigned = productColors.some((productColor) => color.id == productColor.id);
    });


    this.colors = allColors;
    this.product = product;
    this.material = material;
    this.filterState = "assigned";
  }

  filter(colors) {
    switch (this.filterState) {
      case 'assigned':
        return colors.filter((color) => color.assigned == true);
      case 'unassigned':
        return colors.filter((color) => color.assigned != true);
      case 'all':
        return colors;
      default:
        throw new Error("unsupported filter type for colors")
    }
  }

  setFilterState(value, $event) {
    if ($event) {
      $event.preventDefault();
    }
    this.filterState = value;
  }

  changeColorAssigment(color, $event) {
    $event.preventDefault();
    color.__loading = true;
    let
      actionName = '';
    if (color.assigned) {
      actionName = 'deleteProductMaterialColor'
    } else {
      actionName = 'addProductMaterialColor';
    }
    this.ProductsDataProvider[actionName](
      this.product.id,
      this.material.id,
      color.id
    ).then((responseColor) => {
      delete color.__loading;
      color.assigned = !color.assigned;
    });
  }

  toggleCustomColors($event) {
    $event.preventDefault();
    this.customColors = !this.customColors;
  }

  updateName(color, $event) {
    $event.preventDefault();
    color.__loading = true;
    //color.slug=this.onvertToSlug(color.name);    
    this.ProductsDataProvider['updateName'](color, 2).then((responseShape) => {
      delete color.__loading;
    });
  }

onvertToSlug(text) {
  return text
    .toString()
    .normalize('NFKD')                // Bryt ner bokstäver med diakritiska tecken
    .replace(/[\u0300-\u036f]/g, '')  // Ta bort diakritiska tecken (accents)
    .toLowerCase()
    .replace(/å/g, 'a')
    .replace(/ä/g, 'a')
    .replace(/ö/g, 'o')
    .replace(/æ/g, 'ae')
    .replace(/ø/g, 'oe')
    .replace(/\u00fc/g, 'ue')
    .replace(/\s+/g, '-')           // Replace spaces with -
    .replace(/[^\w\-]+/g, '')       // Remove all non-word chars
    .replace(/\-\-+/g, '-')         // Replace multiple - with single -
    .replace(/^-+/, '')             // Trim - from start of text
    .replace(/-+$/, '');            // Trim - from end of text
}
}


// WEBPACK FOOTER //




/** WEBPACK FOOTER **
 ** C:/Users/larss/Documents/signlabs-admin-frontend/client/app/modules/products/components/material-color-spec/controller.js
 **/